import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';

window.addEventListener('DOMContentLoaded', () => {
    const swiperSuccess = new Swiper('.success-list .wp-block-query', {
        modules: [Navigation, Pagination],
        slidesPerView: 1,

        wrapperClass: 'wp-block-post-template',
        slideClass: 'wp-block-post',
        slideActiveClass: 'active',
        navigation: {
            prevEl: '.mobile-pagination-previous',
            nextEl: '.mobile-pagination-next',
        },
        loop: true,
        enabled: true,
        breakpoints: {
            1220: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            970: {
                slidesPerView: 3,
                spaceBetween: 10,
                height: 350
            },
            599: {
                direction: 'horizontal',
                autoHeight: true,
                slidesPerView: 2,
                height: 400
            },
        },

    });
});
